<form [formGroup]="formGroup">
    <ng-container *ngIf="activeStep === stepIndex">
        <div class="form-group">
            <label for="billingEmail">{{ 'billing_email_address' | myLbTranslate }}*</label>
            <div class="form-content">
                <input
                    formControlName="billingEmail"
                    id="billingEmail"
                    name="billingEmail"
                    type="text"
                    autocomplete="one-time-code">
                <app-validation-messages [control]="formGroup.get('billingEmail')">
                </app-validation-messages>
            </div>
        </div>
        <div class="form-group">
            <label for="name">{{ 'billing_name' | myLbTranslate }}*</label>
            <div class="form-content">
                <input
                    formControlName="name"
                    id="name"
                    name="name"
                    type="text"
                    autocomplete="one-time-code">
                <app-validation-messages [control]="formGroup.get('name')">
                </app-validation-messages>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="activeStep > stepIndex">
        <div class="set-content">
            <span>
                <strong>{{ 'billing_email_address' | myLbTranslate }}:</strong>
                {{ formGroup.get('billingEmail').value }}
            </span>
            <span>
                <strong>{{ 'billing_name' | myLbTranslate }}:</strong>
                {{ formGroup.get('name').value }}
            </span>
        </div>
    </ng-container>
</form>
